import { LucideIcon } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { StepHeader } from "./StepHeader";

interface MotivationStepProps {
  icon: LucideIcon;
  title: string;
  description: string;
  motivation: string;
  setMotivation: (value: string) => void;
}

const MOTIVATION_SUGGESTIONS = ["For my family", "Feel confident", "Get healthy", "Prove myself"];

export function MotivationStep({
  icon,
  title,
  description,
  motivation,
  setMotivation,
}: MotivationStepProps) {
  return (
    <div className="w-full max-w-sm animate-fade-in space-y-4">
      <StepHeader icon={icon} title={title} description={description} />

      <div className="space-y-3">
        <Textarea
          placeholder="e.g., For my kids, feeling fit again, proving myself, getting my confidence back..."
          value={motivation}
          onChange={(e) => setMotivation(e.target.value)}
          className="min-h-[100px] bg-secondary/30 border-border/50 resize-none"
        />
        <p className="text-xs text-muted-foreground text-center">
          Optional but helps personalize your experience
        </p>
      </div>

      {/* Quick suggestions */}
      <div className="flex flex-wrap gap-2 justify-center">
        {MOTIVATION_SUGGESTIONS.map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => setMotivation(suggestion)}
            className="px-3 py-1.5 text-xs bg-secondary/50 border border-border/50 rounded-full hover:bg-secondary hover:border-primary/30 transition-all"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}
